import React, { Component } from 'react';
import './calc.css';
import Buttons from './buttons';
import Result from './result';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      result: '0',
      lastButton: '' // Add a property to track the last button clicked
    };
  }

  handleClicks = (value) => {
    let newResult = '';
    let { result } = this.state;

    switch (value) {
      case '0':
      case '1':
      case '2':
      case '3':
      case '4':
      case '5':
      case '6':
      case '7':
      case '8':
      case '9':
        newResult = result === '0' ? value : result + value;
        break;
      case '+':
      case '-':
      case '/':
      case '*':
        const lastChar = result.slice(-1);
        if (!['+', '-', '*', '/'].includes(lastChar)) {
          newResult = result + value;
        }
        break;
      case '.':
        if (!result.includes('.')) {
          newResult = result + value;
        }
        break;
      case 'c':
        newResult = result.slice(0, -1);
        break;
      case 'AC':
        newResult = '0';
        break;
      case '=':
        try {
          newResult = String(eval(result));
        } catch (error) {
          newResult = 'Error';
        }
        break;
      case '%':
        newResult = String(parseFloat(result) / 100);
        break;
      case '+/-':
        newResult = String(parseFloat(result) * -1);
        break;
      default:
        break;
    }

    this.setState({ result: newResult });
  }


  render() {
    return (
        <div id="root">
          <div className="myCalculator">
            <Result result={this.state.result} />
            <Buttons Buttonclicked={this.handleClicks} />
          </div>
        </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/component/App.js